import { User } from '@/entity/authentication/user';
import { WalletService } from '@/service/wallet/wallet.service';
import { EazyPayGatewayService } from '@/service/payment/eazypay-gateway';

export class Wallet {
    async initAmountToWalletForUser(amount: number, user: User): Promise<any> {
        // let link = new EazyPayGatewayService().dummyPaymentLinkForDebitAmountForUser(amount, user)
        let response = await new WalletService().initAmountInUserWallet(amount, user)
        // window.location.href = link
        return Promise.resolve(response);
    }
    async loadAmountToWalletForUser(payment_id: string, order_id : string, signature : string, pgcallbackurl: string): Promise<void> {
        await new WalletService().loadAmountInUserWallet(payment_id, order_id, signature, pgcallbackurl)
        return Promise.resolve();
    }
}